import {
	useState,
	useEffect,
} from 'react'
import {
	Modal,
} from 'react-bootstrap';
import Typography, {
	TypographyType,
} from 'components/typography/karim/Typography';
import {
	ColorBackgroundHEX,
	Colors,
} from 'utils/color/ColorPalette';
import Button, {
	ButtonColor,
} from 'components/button';
import {
	MdOutlineArrowBackIos,
	MdOutlineClose,
} from 'react-icons/md';
import Deviation, {
	getDeviationHeader,
} from './deviation/Deviation';
import './modaldeviation.scss';
import {
	DeviationEnum,
} from 'enum';
import {
	Assignment,
} from 'models';
import {
	DeviationItem,
} from './deviation/DeviationItem';

interface ModalDeviationProps {
	show?: boolean,
	children?: JSX.Element | string,
	assignment: Assignment,
}

const ModalDeviation = ({
	children, show, assignment,
}: ModalDeviationProps) => {

	// To let stacked modals close all underlying modals
	const [hideAllModals, setHideAllModals] = useState(false);

	const [showMainModal, setShowMainModal] = useState(false);

	const handleModalShowHide = (show: boolean) => {
		setShowMainModal(show);
		setHideAllModals(false);
	}

	useEffect(() => {
		if (!!show) {
			setShowMainModal(show);
		}
		setHideAllModals(false);
	}, [show]);

	const [showHideDamagedGoods, setShowHideDamagedGoods] = useState(false);
	const [showHideMissingGoods, setShowHideMissingGoods] = useState(false);
	const [showHideDelayedDeparture, setShowHideDelayedDeparture] = useState(false);
	const [showHideDelayedArrival, setShowHideDelayedArrival] = useState(false);
	const [showHideParkingLotOccupied, setShowHideParkingLotOccupied] = useState(false);
	const [showHidePowerSupplyDamaged, setShowHidePowerSupplyDamaged] = useState(false);
	const [showHidePowerSupplyNotConnected, setShowHidePowerSupplyNotConnected] = useState(false);
	const [showHidePowerSupplyNoFuel, setShowHidePowerSupplyNoFuel] = useState(false);

	// To close of main modal from stacked modals (using x-cross)
	const shouldShow = () => {
		if (hideAllModals) {
			return false;
		}
		else if (showMainModal && (
			!showHideDamagedGoods &&
			!showHideMissingGoods &&
			!showHideDelayedDeparture &&
			!showHideDelayedArrival &&
			!showHideParkingLotOccupied &&
			!showHidePowerSupplyDamaged &&
			!showHidePowerSupplyNotConnected &&
			!showHidePowerSupplyNoFuel)
		) {
			return true;
		}
		return false;
	}
	const onClose = () => {
		setShowHideDamagedGoods(false);
		setShowHideMissingGoods(false);
		setShowHideDelayedDeparture(false);
		setShowHideDelayedArrival(false);
		setShowHideParkingLotOccupied(false);
		setShowMainModal(false);
		setShowHidePowerSupplyDamaged(false);
		setShowHidePowerSupplyNotConnected(false);
		setShowHidePowerSupplyNoFuel(false);
	};

	return (
		<>
			{children &&
          <Button
          	color={ButtonColor.SECONDARY}
          	onClick={() => handleModalShowHide(true)}
          >
          	{children}
          </Button>
			}

			<Modal
				id="deviation-modal"
				dialogClassName="deviation-registration-menu"
				show={shouldShow()}
				onHide={onClose}
				animation
			>
				<Modal.Header>
					<Button color={ButtonColor.COMPACT}>
						<MdOutlineArrowBackIos size={'21px'} color="white"/>
					</Button>
					<Modal.Title>
						<Typography center type={TypographyType.buttonLarge}>Velg avvik</Typography>
					</Modal.Title>
					<Button
						color={ButtonColor.COMPACT}
						onClick={() => handleModalShowHide(!showMainModal)}
					>
						<MdOutlineClose size={'21px'} color={Colors.neutrals.tints.gy400.hex}/>
					</Button>
				</Modal.Header>
				<Modal.Body
					style={{
						backgroundColor: ColorBackgroundHEX.gray.primary,
						overflow: 'scroll',
						maxHeight: '90vh',
						overflowX: 'hidden',
						overflowY: 'auto',
					}}
				>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.DAMAGED_ITEM)}
						show={setShowHideDamagedGoods}
					/>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.MISSING_ITEM)}
						show={setShowHideMissingGoods}
					/>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.DELAYED_DEPARTURE)}
						show={setShowHideDelayedDeparture}
					/>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.DELAYED_ARRIVAL)}
						show={setShowHideDelayedArrival}
					/>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.PARKING_LOT_OCCUPIED)}
						show={setShowHideParkingLotOccupied}
					/>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.POWER_SUPPLY_DAMAGED)}
						show={setShowHidePowerSupplyDamaged}
					/>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.POWER_SUPPLY_NOT_CONNECTED)}
						show={setShowHidePowerSupplyNotConnected}
					/>
					<DeviationItem
						text={getDeviationHeader(DeviationEnum.POWER_SUPPLY_NO_FUEL)}
						show={setShowHidePowerSupplyNoFuel}
					/>
				</Modal.Body>
			</Modal>

			<Deviation
				code={DeviationEnum.DAMAGED_ITEM}
				assignment={assignment}
				onClose={onClose}
				show={showHideDamagedGoods}
				setShow={setShowHideDamagedGoods}
				setHideAllModals={setHideAllModals}
			/>
			<Deviation
				code={DeviationEnum.MISSING_ITEM}
				assignment={assignment}
				onClose={onClose}
				show={showHideMissingGoods}
				setShow={setShowHideMissingGoods}
				setHideAllModals={setHideAllModals}
			/>
			<Deviation
				code={DeviationEnum.DELAYED_DEPARTURE}
				assignment={assignment}
				onClose={onClose}
				show={showHideDelayedDeparture}
				setShow={setShowHideDelayedDeparture}
				setHideAllModals={setHideAllModals}
			/>
			<Deviation
				code={DeviationEnum.DELAYED_ARRIVAL}
				assignment={assignment}
				onClose={onClose}
				show={showHideDelayedArrival}
				setShow={setShowHideDelayedArrival}
				setHideAllModals={setHideAllModals}
			/>
			<Deviation
				code={DeviationEnum.PARKING_LOT_OCCUPIED}
				assignment={assignment}
				onClose={onClose}
				show={showHideParkingLotOccupied}
				setShow={setShowHideParkingLotOccupied}
				setHideAllModals={setHideAllModals}
			/>

			<Deviation
				code={DeviationEnum.POWER_SUPPLY_DAMAGED}
				assignment={assignment}
				onClose={onClose}
				show={showHidePowerSupplyDamaged}
				setShow={setShowHidePowerSupplyDamaged}
				setHideAllModals={setHideAllModals}
			/>
			<Deviation
				code={DeviationEnum.POWER_SUPPLY_NOT_CONNECTED}
				assignment={assignment}
				onClose={onClose}
				show={showHidePowerSupplyNotConnected}
				setShow={setShowHidePowerSupplyNotConnected}
				setHideAllModals={setHideAllModals}
			/>
			<Deviation
				code={DeviationEnum.POWER_SUPPLY_NO_FUEL}
				assignment={assignment}
				onClose={onClose}
				show={showHidePowerSupplyNoFuel}
				setShow={setShowHidePowerSupplyNoFuel}
				setHideAllModals={setHideAllModals}
			/>
		</>
	)
}

export default ModalDeviation;